// import { URLs } from '@common/api';
import { getData, URLs } from '@common/api';
import * as ImageAndText from '@common/models/ImageAndText';
import { call, ForkEffect, put, takeEvery } from 'redux-saga/effects';

import { fetchImageAndTextFailure, fetchImageAndTextRequest, fetchImageAndTextSuccess } from './slice';

export function* fetchImageAndTextSaga({ payload }: Record<string, string>): Generator<unknown> {
  try {
    const data = yield call(() => getData({ url: URLs.GET_IMAGE_AND_TEXT_LAYOUT.replace('{id}', payload) }));
    const result = ImageAndText.processResponse(data.data);
    const { id, layout } = data?.data;
    yield put(fetchImageAndTextSuccess({ id: id, layout: layout, result }));
  } catch (e) {
    console.log('ERROR', e);
    yield put(fetchImageAndTextFailure('Request failed with: ' + e));
  }
}

export default function* heroBannerSagas(): Generator<ForkEffect<never>, void, unknown> {
  yield takeEvery(fetchImageAndTextRequest.type, fetchImageAndTextSaga);
}
